import React, { useState } from 'react';
import styles from './App.module.css';
import Dashboard from './screens/Dashboard';
import Invoices from './screens/Invoices';
import Validation from './screens/Validation';
import Suppliers from './screens/Suppliers';
import Workflow from './screens/Workflow';
import Payment from './screens/Payment';
import Fraud from './screens/Fraud';
import Onboarding from './screens/Onboarding';

const NAV_ITEMS = [
  { id: 'dashboard', icon: 'ti-layout-dashboard', label: 'Dashboard', section: 'Main' },
  { id: 'invoices', icon: 'ti-file-invoice', label: 'Invoices', section: null },
  { id: 'validation', icon: 'ti-shield-check', label: 'AI Validation', section: null },
  { id: 'suppliers', icon: 'ti-building-store', label: 'Suppliers', section: null },
  { id: 'workflow', icon: 'ti-timeline', label: 'Workflow', section: null },
  { id: 'payment', icon: 'ti-credit-card', label: 'Payment Readiness', section: 'Finance' },
  { id: 'fraud', icon: 'ti-alert-triangle', label: 'Fraud Alerts', section: null },
  { id: 'onboarding', icon: 'ti-user-plus', label: 'Onboard Supplier', section: 'Settings' },
  { id: 'settings', icon: 'ti-settings', label: 'Settings', section: null },
];

const TITLES = {
  dashboard: 'CFO Dashboard',
  invoices: 'Invoice List',
  validation: 'AI Validation — INV-2024-1183',
  suppliers: 'Supplier Master',
  workflow: 'Approval Workflow',
  payment: 'Payment Readiness',
  fraud: 'Fraud & Anomaly Alerts',
  onboarding: 'Onboard Supplier',
  settings: 'Settings',
};

const SCREENS = {
  dashboard: Dashboard,
  invoices: Invoices,
  validation: Validation,
  suppliers: Suppliers,
  workflow: Workflow,
  payment: Payment,
  fraud: Fraud,
  onboarding: Onboarding,
};

export default function App() {
  const [active, setActive] = useState('dashboard');
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const Screen = SCREENS[active] || Dashboard;

  return (
    <div className={styles.shell}>
      {/* Mobile overlay */}
      {sidebarOpen && (
        <div className={styles.overlay} onClick={() => setSidebarOpen(false)} />
      )}

      {/* SIDEBAR */}
      <aside className={`${styles.sidebar} ${sidebarOpen ? styles.sidebarOpen : ''}`}>
        <div className={styles.logo}>
          <div className={styles.logoMark}>
            <img src={`${process.env.PUBLIC_URL}/download.png`} alt="Finigenie" className={styles.gem} />
            <div>
              <span className={styles.logoName}>Finigenie</span>
              <span className={styles.logoTag}>CPCL — Vendor Portal</span>
            </div>
          </div>
        </div>
        <nav className={styles.nav}>
          {NAV_ITEMS.map((item) => (
            <React.Fragment key={item.id}>
              {item.section && (
                <div className={styles.navSection}>{item.section}</div>
              )}
              <button
                className={`${styles.navItem} ${active === item.id ? styles.navItemActive : ''}`}
                onClick={() => { setActive(item.id); setSidebarOpen(false); }}
              >
                <i className={`ti ${item.icon}`} />
                <span>{item.label}</span>
              </button>
            </React.Fragment>
          ))}
        </nav>
      </aside>

      {/* MAIN */}
      <div className={styles.main}>
        {/* TOPBAR */}
        <header className={styles.topbar}>
          <div className={styles.topbarLeft}>
            <button className={styles.menuBtn} onClick={() => setSidebarOpen(!sidebarOpen)}>
              <i className="ti ti-menu-2" />
            </button>
            <span className={styles.topbarTitle}>{TITLES[active] || active}</span>
          </div>
          <div className={styles.topbarRight}>
            <span className={styles.topbarDate}>Today, 3 Jul 2026</span>
            <span className={styles.badge}>4 alerts</span>
            <span className={`${styles.badge} ${styles.badgeWarn}`}>8 pending</span>
            <div className={styles.topbarUser}>
              <div className={styles.avatar}>RK</div>
              <span className={styles.topbarUserName}>R. Kumar, CFO</span>
            </div>
          </div>
        </header>

        {/* CONTENT */}
        <main className={styles.content}>
          <Screen navigate={setActive} />
        </main>
      </div>
    </div>
  );
}
